import { ColorSource, Graphics, PointData } from 'pixi.js';
import RENDERER_CONFIG from '@/configs/rendererConfig';

const { COLORS, METRICS } = RENDERER_CONFIG;

abstract class RendererUtils {
	static drawMetricLine(
		from: PointData,
		to: PointData,
		graphics: Graphics,
		isVertical = false,
		color: ColorSource = COLORS.BLACK
	) {
		graphics
			.moveTo(from.x, from.y)
			.lineTo(to.x, to.y)
			.stroke({ color, pixelLine: true });

		if (isVertical) {
			graphics.beginPath();
			graphics.moveTo(
				from.x - METRICS.ARROW_WIDTH / 2,
				from.y + METRICS.ARROW_LENGTH
			);
			graphics.lineTo(from.x, from.y);
			graphics.lineTo(
				from.x + METRICS.ARROW_WIDTH / 2,
				from.y + METRICS.ARROW_LENGTH
			);
			graphics.lineTo(
				from.x - METRICS.ARROW_WIDTH / 2,
				from.y + METRICS.ARROW_LENGTH
			);
			graphics.closePath();
			graphics.fill({ color });

			graphics.beginPath();
			graphics.moveTo(
				to.x - METRICS.ARROW_WIDTH / 2,
				to.y - METRICS.ARROW_LENGTH
			);
			graphics.lineTo(to.x, to.y);
			graphics.lineTo(
				to.x + METRICS.ARROW_WIDTH / 2,
				to.y - METRICS.ARROW_LENGTH
			);
			graphics.lineTo(
				to.x - METRICS.ARROW_WIDTH / 2,
				to.y - METRICS.ARROW_LENGTH
			);
			graphics.closePath();
			graphics.fill();
		} else {
			graphics.beginPath();
			graphics.moveTo(from.x, from.y);
			graphics.moveTo(
				from.x + METRICS.ARROW_LENGTH,
				from.y + METRICS.ARROW_WIDTH / 2
			);
			graphics.lineTo(from.x, from.y);
			graphics.lineTo(
				from.x + METRICS.ARROW_LENGTH,
				from.y - METRICS.ARROW_WIDTH / 2
			);
			graphics.lineTo(
				from.x + METRICS.ARROW_LENGTH,
				from.y + METRICS.ARROW_WIDTH / 2
			);
			graphics.closePath();
			graphics.fill({ color });

			graphics.beginPath();
			graphics.moveTo(
				to.x - METRICS.ARROW_LENGTH,
				to.y + METRICS.ARROW_WIDTH / 2
			);
			graphics.lineTo(to.x, to.y);
			graphics.lineTo(
				to.x - METRICS.ARROW_LENGTH,
				to.y - METRICS.ARROW_WIDTH / 2
			);
			graphics.lineTo(
				to.x - METRICS.ARROW_LENGTH,
				to.y + METRICS.ARROW_WIDTH / 2
			);
			graphics.closePath();
			graphics.fill();
		}
	}

	static drawDash(
		target: Graphics,
		x1: number,
		y1: number,
		x2: number,
		y2: number,
		dashLength = 5,
		spaceLength = 5
	) {
		const x = x2 - x1;
		const y = y2 - y1;
		let hyp = Math.sqrt(x * x + y * y);
		const units = hyp / (dashLength + spaceLength);
		const dashSpaceRatio = dashLength / (dashLength + spaceLength);
		const dashX = (x / units) * dashSpaceRatio;
		const spaceX = x / units - dashX;
		const dashY = (y / units) * dashSpaceRatio;
		const spaceY = y / units - dashY;

		x1 += spaceX;
		y1 += spaceY;
		hyp -= spaceLength;

		target.moveTo(x1, y1);

		while (hyp > 0) {
			x1 += dashX;
			y1 += dashY;
			hyp -= dashLength;
			if (hyp < 0) {
				x1 = x2;
				y1 = y2;
			}
			target.lineTo(x1, y1);
			x1 += spaceX;
			y1 += spaceY;
			target.moveTo(x1, y1);
			hyp -= spaceLength;
		}
		target.moveTo(x2, y2);
	}
}

export default RendererUtils;
